import { useEffect, useState, createContext, useContext } from "react";
import api from "../api";

const SiteContentCtx = createContext({ content: {}, refresh: () => {}, loading: true });

export const SiteContentProvider = ({ children }) => {
  const [content, setContent] = useState({});
  const [loading, setLoading] = useState(true);

  const refresh = async () => {
    try {
      const res = await api.get("/content");
      setContent(res.data || {});
    } catch (e) {
      // Silent fail — components fall back to i18n defaults
      console.warn("Site content fetch failed", e);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    refresh();
  }, []);

  return (
    <SiteContentCtx.Provider value={{ content, refresh, loading }}>
      {children}
    </SiteContentCtx.Provider>
  );
};

export const useSiteContent = () => useContext(SiteContentCtx);

// Convenience helper: get value by key with fallback
export const useContentValue = (key, fallback) => {
  const { content } = useSiteContent();
  const v = content[key];
  if (v === undefined || v === null || v === "") return fallback;
  return v;
};
